import { isDevMode } from '@angular/core';

import { SchemaReference } from '../model/schema-reference.types';

/**
 * Says in dev mode that a reference's part could not be resolved, and what its place shows instead: its
 * `$refStates.error`, or nothing. The node outlet and `resolveSchemaPart` say it alike.
 */
export function reportUnresolved(reference: SchemaReference, failure: unknown): void {
  if (isDevMode()) {
    const shows = reference.$refStates?.error ? 'its $refStates.error' : 'nothing';

    console.warn(`Schema reference "${reference.$ref}" could not be resolved, so its place shows ${shows}.`, failure);
  }
}
